/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import PropTypes from 'prop-types';
import { PortableText } from '@portabletext/react';

import { LocalizedLink } from '@rsc/gatsby-localization-helpers';
import BlockBuilderImage from './types/BlockBuilderImage';
import BlockBuilderLinkGrid from './types/BlockBuilderLinkGrid/BlockBuilderLinkGrid';
import MediaGrid from './types/MediaGrid';
import VideoGallery from './types/VideoGallery';
import BlockBuilderTestimonial from './types/BlockBuilderTestimonial';
import BlockBuilderTestimonialCarousel from './types/BlockBuilderTestimonialCarousel';

function BlockContent({ blocks, getInternalLink }) {
  const internalLink = ({ value, children }) => {
    const href = getInternalLink(value) || '/';
    return <a href={href}>{children}</a>;
  };

  const link = ({ children, value }) => {
    if (value?.linkType === 'internal') {
      const href =
        getInternalLink({ ...value, reference: value?.internalLink }) || '/';

      return (
        <LocalizedLink to={href}>{children || value?.caption}</LocalizedLink>
      );
    }

    return value?.blank ? (
      <a href={value?.href} target="_blank" rel="noreferrer">
        {children}
      </a>
    ) : (
      <a href={value?.href}>{children}</a>
    );
  };

  const mediaGrid = ({ value, getInternalLink }) => (
    <MediaGrid value={value} getInternalLink={getInternalLink} />
  );

  const components = {
    types: {
      blockBuilderTestimonial: BlockBuilderTestimonial,
      blockBuilderTestimonialCarousel: BlockBuilderTestimonialCarousel,
      blockContentImage: BlockBuilderImage,
      blockContentLinkGrid: BlockBuilderLinkGrid,
      mediaGrid: ({ value }) => mediaGrid({ value, getInternalLink }),
      videoGallery: VideoGallery,
      inlineIcon: ({ value }) => (
        <img
          src={value?.icon?.asset?.url}
          width={value?.iconWidth || '16'}
          height={value?.iconHeight || '16'}
          alt="Inline Icon"
          style={{ marginRight: '.25rem' }}
        />
      ),
      internalLink,
      link,
    },
    marks: {
      internalLink,
      link,
    },
    block: {
      normal: ({ children }) => <p>{children}</p>,
      blockquote: ({ children }) => <blockquote>{children}</blockquote>,
      h1: ({ children }) => <h1>{children}</h1>,
      h2: ({ children }) => <h2>{children}</h2>,
      h3: ({ children }) => <h3>{children}</h3>,
      h4: ({ children }) => <h4>{children}</h4>,
      h5: ({ children }) => <h5>{children}</h5>,
      h6: ({ children }) => <h6>{children}</h6>,
    },
    list: {
      bullet: ({ children }) => <ul>{children}</ul>,
      number: ({ children }) => <ol>{children}</ol>,
    },
  };

  return <PortableText value={blocks} components={components} />;
}

BlockContent.propTypes = {
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  getInternalLink: PropTypes.func,
};

BlockContent.defaultProps = {
  getInternalLink: () => {},
};

export default BlockContent;
